import { render } from "./IconBusStopSvg.vue?vue&type=template&id=f1345152"
import script from "./IconBusStopSvg.vue?vue&type=script&lang=js"
export * from "./IconBusStopSvg.vue?vue&type=script&lang=js"
script.render = render

export default script